import {get, post, put, _delete} from './Tools';

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}formula/${id}`);
  return response;
}

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}formula`);
  return response;
}

const getAllByConcept = async (conceptId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}formula/concepto/${conceptId}`);
  return response;
}

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}formula`, payload);
  return response;
}

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}formula`, payload);
  return response;
}

const insertWithRelation = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}formula/concepto`, payload);
  return response;
}

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}formula/${id}`);
  return response;
}

const test = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}formula/test`, payload);
  return response;
}


export { getAll, getAllByConcept, getById, insert, update, insertWithRelation, drop, test };
